import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button,Table } from "react-bootstrap";
import Card from "../../../components/Card";
import ToastNotification from "../../../components/Toast";
// import { API_USERS_SIGNUP } from "../../../service/url";
import { postApiCall,getApiCall, fetchAndSetFlashMessage } from "../../../service/httpCall";
import { useNavigate } from "react-router-dom";
import {getUser} from "../../../utilities/setting";
import { ROUTES } from "../../../utilities/constant";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { API_MODULE_LIST,API_ACL_SETTING_CREATE, API_ACL_SETTING_LIST } from "../../../service/url";
import { USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT} from '../../../utilities/constant';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { toast } from "react-toastify";
import { FaCheck, FaTimes } from "react-icons/fa";

const ACLSettingCreate = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [name, setName] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
 // const [activeUserAccessRole, setActiveUserAccessRole] = useState(undefined);
  const [moduleList, setModuleList] = useState([]);
  const [selectedModules, setSelectedModules] = useState({});
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modulePermission, updateModulePermission] = useState({});
  const [parentACLEnabled, setParentACLEnabled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [notes, setNotes] = useState([]);
  const [defaultForRole, setDefaultForRole] = useState("");
  const [defaultAclRoles, setDefaultAclRoles] = useState([]);
  const [defaultAclRoleNames, setDefaultAclRoleNames] = useState({});

  useEffect(() => {
    async function superadminCheck() {
      const rawUser = await AsyncStorage.getItem('user');
    if (!rawUser) {
      console.error("User not found in AsyncStorage");
      return null; // or handle as needed
    }

      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON in user from AsyncStorage", e);
        return null;
      }
      if (user?.acl_settings?.module_operations) {
        updateModulePermission(JSON.parse(user?.acl_settings?.module_operations));
      }
      if (user.role === USER_ROLES.SUPERADMIN) {
        setIsSuperAdmin(true);
      }
      setLoading(false);
    }

    superadminCheck();

    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.ACL_SETTING_LIST && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
      setNotes
    );
  }, []);

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  useEffect(() => {
    if (!loading) { // Ensure superadminCheck has completed
      getApiCall(API_MODULE_LIST, {})
        .then(onModuleListSuccess)
        .catch(onError);

      // Fetch existing ACLs to know which roles already have a default ACL
      getApiCall(API_ACL_SETTING_LIST, {})
        .then((resp) => {
          const rolesWithDefault = [];
          const roleNameMap = {};

          (resp || [])
            .filter(item => item.default_for_role)
            .forEach(item => {
              rolesWithDefault.push(item.default_for_role);
              // Map role -> ACL name for display
              roleNameMap[item.default_for_role] = item.acl_name;
            });

          setDefaultAclRoles(rolesWithDefault);
          setDefaultAclRoleNames(roleNameMap);
        })
        .catch(onError);
    }
  }, [loading]);

  useEffect(() => {
    checkAuth(setToastProps, setShowToast)
  }, []);

  const constantPermissions = {
    read: false,
    add: false,
    edit: false,
    delete: false,
    view_permission: false
  };
  
  const transformedModuleData = (data) => data.reduce((acc, item) => {
    acc[item.module_name] = { ...constantPermissions };
    return acc;
  }, {});


  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  function onModuleListSuccess(resp) {
    if (isSuperAdmin) {
      setModuleList(resp)
      const moduleOperations = transformedModuleData(resp);
      setSelectedModules(moduleOperations);
    } else {
      getUser().then((user) => {
        if (user) {
          if (user?.acl_settings?.module_operations) {
            let modules = getKeysWithTrueValues(JSON.parse(user?.acl_settings?.module_operations));
            modules = resp.filter(item => modules.includes(item.module_name));
            setModuleList(modules);
            // setSelectedModules(JSON.parse(user?.acl_settings?.module_operations));
            setSelectedModules(transformedModuleData(modules));
          }
        }
      });
    }
  }

  function validateForm() {
    let valid = true;
    if (!name.trim()) {
      valid = false;
      // setToastProps({ message: "Name required", type: "danger" });
          toast.error(`Name required`);
    }
    const isAnyModuleSelected = Object.values(selectedModules).some(module => 
      module.read || module.add || module.edit || module.delete || module.view_permission
    );

    if (!isAnyModuleSelected) {
      valid = false;
      // setToastProps({ message: "Please select at least one module operation", type: "danger" });
          toast.error(`Please select at least one module operation`);
    }
    
    return valid;

}

const normalizePermissions = (modules) => {
    const defaultOps = ["read", "add", "edit", "delete", "view_permission"];

    const normalized = {};

    for (const module in modules) {
      normalized[module] = {};

      defaultOps.forEach(op => {
        normalized[module][op] = modules[module]?.[op] ?? false;
      });
    }

    return normalized;
  };
  

  async function submitForm() {
    setButtonDisable(true);

    if (!validateForm()) {
      setButtonDisable(false);
      return;
    }

    const params = {
      acl_name: name,
      module_operations: normalizePermissions(selectedModules),
      // optional default ACL for a specific child role
      default_for_role: isSuperAdmin ? (defaultForRole || null) : null,
    };
    postApiCall(API_ACL_SETTING_CREATE, params)
    .then(onAClSettingCreateSuccess)
    .catch(onAClSettingCreateError);

}

function onAClSettingCreateSuccess(resp) {
    // setToastProps({ message: 'ACL Setting created successfully', type: 'success' });
          toast.success(`ACL Setting created successfully`);
    setTimeout(() => {
       navigate(`/${ROUTES.ACL_SETTING.LIST}`);
    }, 1500);
 }

  function onAClSettingCreateError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     setButtonDisable(false);
    //  setToastProps({message: JSON.stringify(err), type: 'danger'});
          toast.error(JSON.stringify(err));
   }
  }

  
  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
     errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
     console.log(err)
    }
 }

  const handleCheckboxChange = (moduleName, operation) => {
    // if (isSuperAdmin || modulePermission?.[moduleName]?.[operation]) {
      setSelectedModules((prev) => {

        const updated = {
          ...prev,
          [moduleName]: {
            read: prev?.[moduleName]?.read ?? false,
            add: prev?.[moduleName]?.add ?? false,
            edit: prev?.[moduleName]?.edit ?? false,
            delete: prev?.[moduleName]?.delete ?? false,
            view_permission: prev?.[moduleName]?.view_permission ?? false,
            [operation]: !prev?.[moduleName]?.[operation]
          }
        };

        return updated;
      });

    // } else {
    //   SweetAlert({
    //     text: `Don't have Permission to add ${moduleName} ${operation} operation.`,
    //     icon: "warning",
    //     time: 2000
    //   });
    // }
  };

  const getCheckboxStyle = (isChecked) => ({
    backgroundColor: isChecked ? 'green' : 'red',
    width: '20px',
    height: '20px',
    display: 'inline-block',
    cursor: 'pointer',
    textAlign: 'center',
    lineHeight: '20px',
    color: 'white'
  });

  const handleCheckbox = async (e) => {
    const checked = e.target.checked;
    setParentACLEnabled(checked);

    const user = await getUser();
    if (!user?.acl_settings?.module_operations) return;

    const moduleOps = JSON.parse(user.acl_settings.module_operations);

    if (checked) {
      // CHECKED logic
      setSelectedModules(moduleOps);
    } else {
      // UNCHECKED logic
      const modules = getKeysWithTrueValues(moduleOps);
      setSelectedModules(transformedModuleData(modules));
    }
  };

  const handleSelectAllPermissions = (moduleName) => {
    setSelectedModules((prev) => {
      const current = prev[moduleName] || {};

      const isAllSelected =
        current.read &&
        current.add &&
        current.edit &&
        current.delete &&
        current.view_permission;

      return {
        ...prev,
        [moduleName]: {
          read: !isAllSelected,
          add: !isAllSelected,
          edit: !isAllSelected,
          delete: !isAllSelected,
          view_permission: !isAllSelected
        }
      };
    });
  };


  const filteredModules = moduleList
    .slice()
    .sort((a, b) =>
      a.module_name.localeCompare(b.module_name)
    )
    .filter((module) =>
      module.module_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
  );



  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">Create ACL Settings</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                  <div className="row">
                    <Form.Group className="col-md-4 form-group">
                      <Form.Label>ACL Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                      <Form.Control
                        type="text"
                        id="name"
                        placeholder="ACL Name"
                        maxLength={100}
                        value={name}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z0-9_ ]*$/.test(value)) {
                            setName(value);
                          }
                        }}
                        required
                      />
                    </Form.Group>

                    {isSuperAdmin && (
                      <Form.Group className="col-md-4 form-group">
                        <Form.Label>Default for Role (optional)</Form.Label>
                        <Form.Select
                          value={defaultForRole}
                          onChange={(e) => setDefaultForRole(e.target.value)}
                        >
                          <option value="">None</option>
                          <option
                            value={USER_ROLES.RESELLER}
                            disabled={defaultAclRoles.includes(USER_ROLES.RESELLER)}
                          >
                            {defaultAclRoles.includes(USER_ROLES.RESELLER)
                              ? `Reseller (${defaultAclRoleNames[USER_ROLES.RESELLER] || "Default ACL"})`
                              : "Reseller"}
                          </option>
                          <option
                            value={USER_ROLES.COMPANY_ADMIN}
                            disabled={defaultAclRoles.includes(USER_ROLES.COMPANY_ADMIN)}
                          >
                            {defaultAclRoles.includes(USER_ROLES.COMPANY_ADMIN)
                              ? `Company Admin (${defaultAclRoleNames[USER_ROLES.COMPANY_ADMIN] || "Default ACL"})`
                              : "Company Admin"}
                          </option>
                          <option
                            value={USER_ROLES.CALL_CENTRE_ADMIN}
                            disabled={defaultAclRoles.includes(USER_ROLES.CALL_CENTRE_ADMIN)}
                          >
                            {defaultAclRoles.includes(USER_ROLES.CALL_CENTRE_ADMIN)
                              ? `Call Centre Admin (${defaultAclRoleNames[USER_ROLES.CALL_CENTRE_ADMIN] || "Default ACL"})`
                              : "Call Centre Admin"}
                          </option>
                          <option
                            value={USER_ROLES.CALL_CENTRE_AGENT}
                            disabled={defaultAclRoles.includes(USER_ROLES.CALL_CENTRE_AGENT)}
                          >
                            {defaultAclRoles.includes(USER_ROLES.CALL_CENTRE_AGENT)
                              ? `Call Centre Agent (${defaultAclRoleNames[USER_ROLES.CALL_CENTRE_AGENT] || "Default ACL"})`
                              : "Call Centre Agent"}
                          </option>
                        </Form.Select>
                      </Form.Group>
                    )}

                    {!isSuperAdmin && (
                      <Form.Group className="col-md-4 form-group d-flex align-items-center">
                        <Form.Check
                          type="checkbox"
                          id="aclCheckbox"
                          label="Apply Parent's ACL"
                          checked={parentACLEnabled}
                          onChange={handleCheckbox}
                        />
                      </Form.Group>
                    )}

                  </div>


                  <div
                    className="header-title"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap"
                    }}
                  >
                    <h6 className="card-title mb-0">
                      Please Select Module Operations
                    </h6>

                    <div
                      style={{
                        background: "#FFF8C6",
                        color: "#8B5A2B",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: 500,
                        // whiteSpace: "nowrap",
                        margin: "5px"
                      }}
                    >
                      {/* <strong>Note:</strong> Only modules with <b>View Permission</b> enabled will be visible in the user sidebar. */}
                      <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}

                      
                    </div>
                  </div>

                  <Form.Group className="col-md-6 form-group mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search module..."
                        value={searchTerm}
                        style={{ marginTop: "20px", marginBottom: "20px", width: "300px" }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </Form.Group>


                   {moduleList.length === 0 ? (
                      <div>No modules added</div>
                    ) : (
                  <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>Module Name</th>
                      <th>Read</th>
                      <th>Add</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>View Permission</th>
                      <th>Select / Deselect All</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredModules.map((module, index) => (
                      <tr key={index}>
                        <td>{module.module_name}</td>
                        <td>
                          <div
                            className={`permission-pill ${
                              selectedModules[module.module_name]?.read ? "active" : ""
                            }`}
                            onClick={() =>
                              handleCheckboxChange(module.module_name, "read")
                            }
                          >
                            <span className="pill-icon">
                              {selectedModules[module.module_name]?.read ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                            </span>
                          </div>
                        </td>
                        <td>
                        <div
                          className={`permission-pill read ${
                            selectedModules[module.module_name]?.add ? "active" : ""
                          }`}
                          onClick={() => handleCheckboxChange(module.module_name, "add")}
                        >
                          <span className="pill-icon">
                            {selectedModules[module.module_name]?.add ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div
                          className={`permission-pill edit ${
                            selectedModules[module.module_name]?.edit ? "active" : ""
                          }`}
                          onClick={() => handleCheckboxChange(module.module_name, "edit")}
                        >
                          <span className="pill-icon">
                            {selectedModules[module.module_name]?.edit ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div
                          className={`permission-pill delete ${
                            selectedModules[module.module_name]?.delete ? "active" : ""
                          }`}
                          onClick={() => handleCheckboxChange(module.module_name, "delete")}
                        >
                          <span className="pill-icon">
                            {selectedModules[module.module_name]?.delete ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                          </span>
                        </div>
                      </td>

                      <td>
                        <div
                          className={`permission-pill view ${
                            selectedModules[module.module_name]?.view_permission ? "active" : ""
                          }`}
                          onClick={() =>
                            handleCheckboxChange(module.module_name, "view_permission")
                          }
                        >
                          <span className="pill-icon">
                            {selectedModules[module.module_name]?.view_permission ? <FaCheck className="perm-icon" /> : <FaTimes className="perm-icon off" />}
                          </span>
                        </div>
                        </td>
                        <td>
                          <Form.Check
                            type="checkbox"
                            className="shadow-checkbox"
                            checked={
                              selectedModules[module.module_name]?.read &&
                              selectedModules[module.module_name]?.add &&
                              selectedModules[module.module_name]?.edit &&
                              selectedModules[module.module_name]?.delete &&
                              selectedModules[module.module_name]?.view_permission
                            }
                            onChange={() =>
                              handleSelectAllPermissions(module.module_name)
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  </Table>
                    )}
          
                    <Button
                      onClick={async () => {
                        submitForm();
                      }}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable}
                    >
                      Add ACL &nbsp;
                      {buttonDisable ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <style>
        {`
          .shadow-checkbox .form-check-input {
            box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
          }
        `}
      </style>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};
export default ACLSettingCreate;
